import {browserLosslessWasm} from './browserLossless.wasm';

type Decoder = {memory: WebAssembly.Memory; __heap_base: WebAssembly.Global; decode(input:number,length:number,output:number,size:number):number};
let decoder: Decoder | null | undefined;
export function supportsBrowserLossless(): boolean {
  if (decoder === undefined) {
    try {decoder = new WebAssembly.Instance(new WebAssembly.Module(browserLosslessWasm)).exports as Decoder;}
    catch {decoder = null;}
  }
  return decoder !== null;
}
/** Bounded independent Zstandard frame. RGBA bytes retain source color and alpha. */
export function decodeBrowserLossless(input: Uint8Array, size: number): Uint8ClampedArray<ArrayBuffer> {
  if (!Number.isSafeInteger(size) || size < 1 || size > 3840 * 2160 * 4 || !input.length || input.length > size + 65536) throw new Error('Invalid lossless Browser block');
  if (!supportsBrowserLossless() || !decoder) throw new Error('Lossless Browser decoder unavailable');
  const start=Number(decoder.__heap_base.value),output=start+input.length,required=output+size;
  const memory=decoder.memory;
  if(required>memory.buffer.byteLength)memory.grow(Math.ceil((required-memory.buffer.byteLength)/65536));
  new Uint8Array(memory.buffer,start,input.length).set(input);
  if(!decoder.decode(start,input.length,output,size))throw new Error('Invalid lossless Browser block');
  // Each queued picture owns its pixels; subsequent decodes reuse only the workspace.
  return new Uint8ClampedArray(memory.buffer,output,size).slice();
}
